import { render, staticRenderFns } from "./admin-package-edit.vue?vue&type=template&id=6769c1fd&scoped=true&"
import script from "./admin-package-edit.vue?vue&type=script&lang=js&"
export * from "./admin-package-edit.vue?vue&type=script&lang=js&"
import style0 from "./admin-package-edit.vue?vue&type=style&index=0&id=6769c1fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6769c1fd",
  null
  
)

export default component.exports